import {
  FaTruck,
  FaShippingFast,
  FaSnowflake,
  FaIndustry,
  FaBolt,
  FaCheckCircle,
  FaArrowRight,
} from 'react-icons/fa'
import { Link } from 'react-router-dom'
import SEO from '../../lib/SEO'
import TruckSVG from '../../components/TruckSVG'
import styles from './services.module.scss'

const services = [
  {
    icon: <FaTruck />,
    title: 'Full Truckload (FTL)',
    desc: 'A dedicated 53-ft trailer for your cargo alone. Direct route, fastest transit, no stops. Ideal for shipments over 10,000 lbs or when you need the whole truck.',
    features: [
      'Dry van & flatbed options',
      'Direct point-to-point routing',
      'Coast-to-coast coverage',
      'Priority scheduling',
      'Oversized available',
    ],
  },
  {
    icon: <FaShippingFast />,
    title: 'Less-Than-Truckload (LTL)',
    desc: 'Share trailer space with other shippers — you pay only for the space your freight occupies. Reliable, affordable, nationwide network.',
    features: [
      '150 – 10,000 lbs',
      'Freight class optimization',
      'Liftgate & inside delivery',
      'Consolidated hub network',
      'Pallet & crated freight',
    ],
  },
  {
    icon: <FaBolt />,
    title: 'Expedited Freight',
    desc: 'When time is the only thing that matters. Team drivers run non-stop. Guaranteed pickup within 2 hours of booking. No exceptions.',
    features: [
      '2-hour pickup guarantee',
      'Team driver non-stop runs',
      'Sprinter van to 53-ft trailer',
      'Direct, no-transfer routes',
      'Real-time status updates',
    ],
  },
  {
    icon: <FaSnowflake />,
    title: 'Refrigerated / Reefer',
    desc: 'Temperature-controlled transport for food, pharma, dairy, and perishables. Continuous digital monitoring. FSMA and FDA compliant.',
    features: [
      '-20°F to +70°F range',
      'Continuous temp logging',
      'FSMA / FDA compliant',
      'Pharmaceutical-grade trailers',
      'Pre-cooled on dispatch',
    ],
  },
  {
    icon: <FaIndustry />,
    title: 'Flatbed & Specialized',
    desc: "Flatbed, step-deck, lowboy, RGN — for cargo that doesn't fit a standard box. Heavy equipment, steel, lumber, construction supplies, wind turbines.",
    features: [
      'Flatbed & step-deck',
      'Lowboy & RGN trailers',
      'Oversize / overweight permits',
      'Pilot car coordination',
      'Up to 200,000 lbs GVW',
    ],
  },
]

const Services = () => (
  <>
    <SEO
      title='Freight Services – Vision International | FTL, LTL, Expedited & More'
      description='Vision International offers FTL, LTL, expedited, refrigerated, and flatbed freight services across all 48 states. Get a free quote.'
      keywords='FTL trucking, LTL freight, expedited shipping, refrigerated transport, flatbed freight, Vision International'
      canonical='https://vi4u.net/services'
    />

    <div className={styles.page}>
      <div className={styles.hero}>
        <div className={styles.heroInner}>
          <span className={styles.label}>What We Haul</span>
          <h1 className={styles.title}>Our Services</h1>
          <p>Every load size. Every route. Every piece of equipment you need.</p>
        </div>
        <div className={styles.heroTruck}>
          <TruckSVG
            variant='dark'
            className={styles.truckSvg}
          />
        </div>
      </div>

      <div className={styles.grid}>
        {services.map((s, i) => (
          <div
            key={i}
            className={styles.card}
          >
            <div className={styles.cardIcon}>{s.icon}</div>
            <h2>{s.title}</h2>
            <p className={styles.cardDesc}>{s.desc}</p>
            <ul>
              {s.features.map((f, j) => (
                <li key={j}>
                  <FaCheckCircle /> {f}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className={styles.cta}>
        <h2>Need a custom solution?</h2>
        <p>Tell us about your freight — we will build a plan that works.</p>
        <Link
          to='/contact-us'
          className={styles.ctaBtn}
        >
          Get a Free Quote <FaArrowRight />
        </Link>
      </div>
    </div>
  </>
)

export default Services
